import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'

import {
  googleUnassignOpenAtom,
  telegramUnassignOpenAtom,
} from '@root/features/settings/settings-screen'
import { useBreakpoint } from '@root/shared'
import { ConfirmDialog, ConfirmDrawer } from '@root/shared/ui-kit'

import type { reatomUnassignGoogle } from '@root/features/auth'
import type { reatomUnassignTelegram } from '@root/features/auth/telegram'

type Props = {
  unassignTelegramModel: ReturnType<typeof reatomUnassignTelegram>
  unassignGoogleModel: ReturnType<typeof reatomUnassignGoogle>
}
export const SettingsSocialsConfirm: React.FC<Props> = ({
  unassignTelegramModel,
  unassignGoogleModel,
}) => {
  const { t } = useTranslation()
  const breakpoint = useBreakpoint()

  const [telegramUnassignOpen, setTelegramUnassignOpen] = useAtom(
    telegramUnassignOpenAtom,
  )
  const [googleUnassignOpen, setGoogleUnassignOpen] = useAtom(
    googleUnassignOpenAtom,
  )

  const [unassignTelegramState] = useAtom(unassignTelegramModel)
  const unassignTelegram = useAction(unassignTelegramModel.execute)
  const [unassignGoogleState] = useAtom(unassignGoogleModel)
  const unassignGoogle = useAction(unassignGoogleModel.execute)

  const ConfirmCmp = breakpoint === 'mobile' ? ConfirmDrawer : ConfirmDialog

  return (
    <>
      <ConfirmCmp
        intent="error"
        open={telegramUnassignOpen}
        onOpenChange={setTelegramUnassignOpen}
        title={t('settings.telegram.disconnect-title')}
        describedBy={t('settings.telegram.disconnect-title')}
        description={t('settings.telegram.disconnect-description')}
        busy={unassignTelegramState.loading}
        onConfirm={() => unassignTelegram()}
        onCancel={() => setTelegramUnassignOpen(false)}
      />
      <ConfirmCmp
        intent="error"
        open={googleUnassignOpen}
        onOpenChange={setGoogleUnassignOpen}
        title={t('settings.google.disconnect-title')}
        describedBy={t('settings.google.disconnect-title')}
        description={t('settings.google.disconnect-description')}
        busy={unassignGoogleState.loading}
        onConfirm={() => unassignGoogle()}
        onCancel={() => setGoogleUnassignOpen(false)}
      />
    </>
  )
}
